export default [
  {
    id: 1,
    name: 'Married and entitled to file joint tax returns',
    label: 'Married and entitled to file joint tax returns',
    value: 'married_joint_tax_returns',
  },
  {
    id: 2,
    name: 'Single Parents with dependent child',
    label: 'Single Parents with dependent child',
    value: 'single_parents_dependent_child',
  },
  {
    id: 3,
    name: 'Receiving TANF assistance',
    label: 'Receiving TANF assistance',
    value: 'receiving_tanf_assistance',
  },
  {
    id: 4,
    name: 'Job Training Program',
    label: 'Job Training Program',
    value: 'job_training_program',
  },
  {
    id: 5,
    name: 'Previously in foster care',
    label: 'Previously in foster care',
    value: 'previously_in_foster_care',
  },
  {
    id: 6,
    name: 'None are applicable',
    label: 'None are applicable',
    value: 'none_applicable',
  },
];
